import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-da3a9208"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrap" };
var _hoisted_2 = { class: "content" };
var _hoisted_3 = ["onClick"];
var _hoisted_4 = { class: "product-title" };
var _hoisted_5 = /*#__PURE__*/ _createTextVNode("待审核");
var _hoisted_6 = /*#__PURE__*/ _createTextVNode("审核通过");
var _hoisted_7 = /*#__PURE__*/ _createTextVNode("审核未通过");
var _hoisted_8 = /*#__PURE__*/ _createTextVNode("套餐价格");
var _hoisted_9 = /*#__PURE__*/ _createTextVNode("受检姓名");
var _hoisted_10 = /*#__PURE__*/ _createTextVNode("样本编号");
var _hoisted_11 = /*#__PURE__*/ _createTextVNode("下单时间");
import { ref, reactive } from "vue";
import { queryDoctorReportsList } from "@/api";
import { List, NavBar, Tag, Row, Col, Tabs, Tab, Toast } from "vant";
import { debounce } from "@/utils";
import router from "@/router";
export default /*#__PURE__*/ _defineComponent({
    __name: 'List',
    setup: function (__props) {
        var _this = this;
        var active = ref("0");
        var loading = ref(false);
        var finished = ref(false);
        var productsList = ref([]);
        var pageParams = reactive({
            pageIndex: 0,
            pageSize: 10,
        });
        var getList = function () { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        pageParams.pageIndex++;
                        return [4 /*yield*/, queryDoctorReportsList({
                                pageIndex: pageParams.pageIndex,
                                pageSize: pageParams.pageSize,
                                data: active.value === "0" ? [] : active.value === "1" ? [1] : [2, 3],
                            })];
                    case 1:
                        res = _a.sent();
                        loading.value = false;
                        if (res.code === 200) {
                            if (pageParams.pageIndex === 1) {
                                productsList.value = [];
                            }
                            productsList.value = productsList.value.concat(res.data.records);
                            if (res.data.pages <= pageParams.pageIndex) {
                                finished.value = true;
                            }
                        }
                        else {
                            Toast(res.message);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var debounceGetList = debounce(getList, 300);
        var onLoad = function () {
            loading.value = true;
            debounceGetList();
        };
        var handleChange = function () {
            pageParams.pageIndex = 0;
            productsList.value = [];
            onLoad();
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(NavBar), {
                    title: "样本报告列表",
                    onClickLeft: _cache[0] || (_cache[0] = function () { })
                }),
                _createVNode(_unref(Tabs), {
                    active: active.value,
                    "onUpdate:active": _cache[2] || (_cache[2] = function ($event) { return ((active).value = $event); }),
                    color: "#3DABA4",
                    sticky: "",
                    onClick: handleChange
                }, {
                    default: _withCtx(function () { return [
                        _createVNode(_unref(Tab), {
                            name: "0",
                            title: "全部"
                        }),
                        _createVNode(_unref(Tab), {
                            name: "1",
                            title: "待审核"
                        }),
                        _createVNode(_unref(Tab), {
                            name: "[2, 3]",
                            title: "已完成"
                        }),
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_unref(List), {
                                style: _normalizeStyle({ marginTop: '0.32rem' }),
                                loading: loading.value,
                                "onUpdate:loading": _cache[1] || (_cache[1] = function ($event) { return ((loading).value = $event); }),
                                finished: finished.value,
                                "finished-text": "没有更多了",
                                onLoad: onLoad
                            }, {
                                default: _withCtx(function () { return [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productsList.value, function (item) {
                                        return (_openBlock(), _createElementBlock("div", {
                                            class: "product-item",
                                            key: item.id,
                                            onClick: function ($event) { return (_unref(router).push("/doctor-report-detail?reportUrl=" + item.reportUrl + "&reportId=" + item.reportId + "&reportStatus=" + item.reportStatus)); }
                                        }, [
                                            _createElementVNode("div", {
                                                style: _normalizeStyle({ flex: 'auto', padding: '0.32rem' })
                                            }, [
                                                _createElementVNode("p", _hoisted_4, [
                                                    _createTextVNode(_toDisplayString(item.skuName), 1),
                                                    (item.reportStatus === 1)
                                                        ? (_openBlock(), _createBlock(_unref(Tag), {
                                                            key: 0,
                                                            style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                            type: "warning"
                                                        }, {
                                                            default: _withCtx(function () { return [
                                                                _hoisted_5
                                                            ]; }),
                                                            _: 1
                                                        }, 8, ["style"]))
                                                        : _createCommentVNode("", true),
                                                    (item.reportStatus === 2)
                                                        ? (_openBlock(), _createBlock(_unref(Tag), {
                                                            key: 1,
                                                            style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                            type: "success"
                                                        }, {
                                                            default: _withCtx(function () { return [
                                                                _hoisted_6
                                                            ]; }),
                                                            _: 1
                                                        }, 8, ["style"]))
                                                        : _createCommentVNode("", true),
                                                    (item.reportStatus === 3)
                                                        ? (_openBlock(), _createBlock(_unref(Tag), {
                                                            key: 2,
                                                            style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                            type: "danger"
                                                        }, {
                                                            default: _withCtx(function () { return [
                                                                _hoisted_7
                                                            ]; }),
                                                            _: 1
                                                        }, 8, ["style"]))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _createVNode(_unref(Row), { class: "order-field" }, {
                                                    default: _withCtx(function () { return [
                                                        _createVNode(_unref(Col), {
                                                            class: "order-field-title",
                                                            span: "6"
                                                        }, {
                                                            default: _withCtx(function () { return [
                                                                _hoisted_8
                                                            ]; }),
                                                            _: 1
                                                        }),
                                                        _createVNode(_unref(Col), { span: "18" }, {
                                                            default: _withCtx(function () { return [
                                                                _createTextVNode(_toDisplayString(item.orderPrice), 1)
                                                            ]; }),
                                                            _: 2
                                                        }, 1024)
                                                    ]; }),
                                                    _: 2
                                                }, 1024),
                                                _createVNode(_unref(Row), { class: "order-field" }, {
                                                    default: _withCtx(function () { return [
                                                        _createVNode(_unref(Col), {
                                                            class: "order-field-title",
                                                            span: "6"
                                                        }, {
                                                            default: _withCtx(function () { return [
                                                                _hoisted_9
                                                            ]; }),
                                                            _: 1
                                                        }),
                                                        _createVNode(_unref(Col), { span: "18" }, {
                                                            default: _withCtx(function () { return [
                                                                _createTextVNode(_toDisplayString(item.testUserName), 1)
                                                            ]; }),
                                                            _: 2
                                                        }, 1024)
                                                    ]; }),
                                                    _: 2
                                                }, 1024),
                                                _createVNode(_unref(Row), { class: "order-field" }, {
                                                    default: _withCtx(function () { return [
                                                        _createVNode(_unref(Col), {
                                                            class: "order-field-title",
                                                            span: "6"
                                                        }, {
                                                            default: _withCtx(function () { return [
                                                                _hoisted_10
                                                            ]; }),
                                                            _: 1
                                                        }),
                                                        _createVNode(_unref(Col), { span: "18" }, {
                                                            default: _withCtx(function () { return [
                                                                _createTextVNode(_toDisplayString(item.sampleCode), 1)
                                                            ]; }),
                                                            _: 2
                                                        }, 1024)
                                                    ]; }),
                                                    _: 2
                                                }, 1024),
                                                _createVNode(_unref(Row), { class: "order-field" }, {
                                                    default: _withCtx(function () { return [
                                                        _createVNode(_unref(Col), {
                                                            class: "order-field-title",
                                                            span: "6"
                                                        }, {
                                                            default: _withCtx(function () { return [
                                                                _hoisted_11
                                                            ]; }),
                                                            _: 1
                                                        }),
                                                        _createVNode(_unref(Col), { span: "18" }, {
                                                            default: _withCtx(function () { return [
                                                                _createTextVNode(_toDisplayString(item.reportTime), 1)
                                                            ]; }),
                                                            _: 2
                                                        }, 1024)
                                                    ]; }),
                                                    _: 2
                                                }, 1024)
                                            ], 4)
                                        ], 8, _hoisted_3));
                                    }), 128))
                                ]; }),
                                _: 1
                            }, 8, ["style", "loading", "finished"])
                        ])
                    ]; }),
                    _: 1
                }, 8, ["active"])
            ]));
        };
    }
});
